module.exports = __webpack_public_path__ + "static/media/2D.65abe833.svg";